// src/pages/HomePage.jsx
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
  VStack,
  Icon,
} from "@chakra-ui/react";
import { useColorMode, useColorModeValue } from "./ui/color-mode";
import { FaSolarPanel } from "react-icons/fa";

export default function HomePage() {
  const navigate = useNavigate();
  const { colorMode } = useColorMode();

  // Keep gradient for hero banner
  const gradientLight = "linear(to-br, brand.500, brand.700)";
  const gradientDark = "linear(to-br, blue.500, blue.700)";
  const bgGradient = colorMode === "light" ? gradientLight : gradientDark;

  // Light background page
  const pageBg = useColorModeValue("white", "gray.900");

  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.300");
  const titleColor = "white";
  const subColor = "whiteAlpha.900";

  const headingColor = useColorModeValue("blue.600", "blue.300");
  const textColor = useColorModeValue("gray.700", "gray.300");

  return (
    <Flex minH="100vh" direction="column" bg={pageBg}>
      {/* Hero band */}
      <Box
        bgGradient={bgGradient}
        py={{ base: 12, md: 16 }}
        px={4}
        boxShadow="md"
      >
        <Container maxW="4xl">
          <VStack spacing={4} align="start" color={titleColor}>
            <Icon as={FaSolarPanel} boxSize={10} />
            <Heading size="2xl" lineHeight="1.2">
              Willkommen bei Envaris
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color={subColor}
              opacity={0.95}
            >
              Verwalte Photovoltaikanlagen, Wartung und Partner effizient – in
              einem modernen, übersichtlichen Dashboard.
            </Text>
          </VStack>
        </Container>
      </Box>

      {/* Action Card */}
      <Flex
        flex="1"
        align="center"
        justify="center"
        px={4}
        py={{ base: 8, md: 12 }}
      >
        <Container maxW="lg">
          <Box
            bg={cardBg}
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="2xl"
            boxShadow="xl"
            p={{ base: 6, md: 8 }}
            textAlign="center"
          >
            <Heading size="md" mb={2} color={headingColor}>
              
            </Heading>
            <Text color={textColor} mb={6}>
              Melde dich an oder erstelle ein neues Konto, um fortzufahren.
            </Text>

            <VStack spacing={4}>
              {/* Primary blue button */}
              <Button
                w="100%"
                size="lg"
                bg="blue.500"
                color="white"
                _hover={{ bg: "blue.600" }}
                onClick={() => navigate("/login")}
              >
                🔐 Login
              </Button>

              {/* Outline button but with blue text */}
              <Button
                w="100%"
                size="lg"
                variant="outline"
                borderColor="blue.500"
                color="blue.500"
                _hover={{ bg: "blue.50" }}
                onClick={() => navigate("/register")}
              >
                ✍️ Registrieren
              </Button>
            </VStack>
          </Box>
        </Container>
      </Flex>
    </Flex>
  );
}